import { useFpB2bCouponService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-coupon-service'
import { CouponCondition } from '@cart-ui/CouponCondition/CouponCondition'
import { RegularGiveawayProgressBar } from '@cart-ui/RegularGiveawayProgressBar/RegularGiveawayProgressBar'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { ResponsiveDialog } from '@pets-ui/ResponsiveDialog/ResponsiveDialog'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { formatPrice } from '@utils'
import { useMemo } from 'react'
import { useProductCatalog } from '../../../../fp-b2b-shared/hooks/use-product-catalog'

interface DialogRegularGiveawayTipsProps {
  open: boolean
  onClose: () => void
}

export function DialogRegularGiveawayTips(props: DialogRegularGiveawayTipsProps) {
  const { open, onClose } = props
  const { currency, projectCode, campaignId, countryCode, campaignCode, platform } = useProductCatalog()
  const { regularGiveaways, getRegularGiveawayProgress } = useFpB2bCouponService(
    campaignId,
    projectCode,
    countryCode,
    campaignCode,
    platform,
  )
  const { totalAmount, percentage, totalCriterions, currentCriterions, subtractionTotal } = useMemo(() => getRegularGiveawayProgress(regularGiveaways), [regularGiveaways, getRegularGiveawayProgress])

  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      fullWidth
    >
      <DialogHeader title="滿額禮" />
      <DialogContent pb={4}>
        <VStack gap={2}>
          <Text
            variant="caption"
            color={colors.red600}
          >
            {percentage < 100 && `還差 ${formatPrice(currency, subtractionTotal)}`}
          </Text>
          <RegularGiveawayProgressBar
            total={totalCriterions}
            current={currentCriterions}
            value={percentage}
          />
          {regularGiveaways?.flatMap(regularGiveaway => regularGiveaway.criterions.map(criterion => (
            <CouponCondition
              key={criterion.display_name}
              displayName={criterion.display_name}
              isApplied={totalAmount >= (criterion.criterion_amount ?? 0)}
              currency={currency}
              moreAmount={(criterion.criterion_amount ?? 0) - totalAmount}
              moreQuantity={criterion.left_quantity ?? criterion.display_criterion_quantity}
              count={criterion.count}
            />
          )))}
        </VStack>
      </DialogContent>
    </ResponsiveDialog>
  )
}
